var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.91992 0.0820312C3.15992 0.0820312 0.919922 2.32203 0.919922 5.08203C0.919922 7.84203 3.15992 10.082 5.91992 10.082C8.67992 10.082 10.9199 7.84203 10.9199 5.08203C10.9199 2.32203 8.67992 0.0820312 5.91992 0.0820312ZM4.56492 7.22703L2.76992 5.43203C2.57492 5.23703 2.57492 4.92203 2.76992 4.72703C2.96492 4.53203 3.27992 4.53203 3.47492 4.72703L4.91992 6.16703L8.35992 2.72703C8.55492 2.53203 8.86992 2.53203 9.06492 2.72703C9.25992 2.92203 9.25992 3.23703 9.06492 3.43203L5.26992 7.22703C5.07992 7.42203 4.75992 7.42203 4.56492 7.22703Z",
    fill: "#18B368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/checkGreen.a6380c5d9205e9ce3d65af6f6f482521.svg";
export { ForwardRef as ReactComponent };